
<template>
  <div class="content">
    <div class="title-box" >
      <el-button type="default" size="small" @click="back()">返回</el-button>
      <span>{{ txt }}</span>
    </div>

    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
      <div class="back-color-fff form-box">
        <span class="form-title">基础信息</span>
        <div class="form-item-box"></div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="公司名称" prop="tenantGuid">
              <el-select
                v-model="ruleForm.tenantGuid"
                placeholder="请选择"
                filterable
                class="w300"
                @change="tenantChange"
              >
                <el-option
                  v-for="item in tenantList"
                  :key="item.sendTenantGuid"
                  :label="item.sendTenantName"
                  :value="item.sendTenantGuid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="药店类型" prop="terminalProperty">
              <el-select v-model="ruleForm.terminalProperty" placeholder="请选择" class="w300">
                <el-option v-for="item in customerTypeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
          <el-form-item label="标注位置" prop="markers">
            <div class="map-a-sty" v-if="!ruleForm.markers" @click="showMap"><i class="el-icon-plus"></i> 选择地图</div>
            <div v-if="ruleForm.markers" class="map-a-sty" @click="showMap"><i class="el-icon-plus"></i> 重新选择</div>
            <div v-if="ruleForm.markers && ruleForm.markers.lat">经度：{{ ruleForm.markers.lng || ''}}，纬度：{{ ruleForm.markers.lat || ''}}</div>
            <div class="fontC-4fa1a4">提示：请确认定位准确，以免影响客户拜访定位</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址" prop="address">
            <el-input type="textarea" v-model="ruleForm.address" class="w300" placeholder="请输入" :maxlength="100" clearable></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="12" v-show="ruleForm.terminalProperty == '连锁门店'">
            <!-- 新增字段-连锁总部 -->
            <el-form-item label="连锁总部" >
              <el-select
                v-model="ruleForm.chainHeadquartesGuid"
                class="w300"
                filterable
                remote
                :remote-method="getChainHeadquartes"
                placeholder="请选择"
                @change="changeChainHeadquartesName"
              >
                <el-option
                  v-for="item in chainHeadquartesOption"
                  :key="item.commonGuid"
                  :label="item.customerName"
                  :value="item.commonGuid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        
        <el-col :span="12">
          <el-form-item :label="ruleForm.terminalProperty == '连锁门店'?'分店名称':'药店名称'" prop="customerName">
            <el-input v-model="ruleForm.customerName" class="w300" placeholder="请输入" :maxlength="50" @blur="checkCommonCustomer(ruleForm.customerName)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-show="ruleForm.terminalProperty == '连锁总部'">
          <el-form-item label="直营门店数量" >
            <el-input-number v-model="ruleForm.directStoresNum"  :min="0" :max="1000000" label="请输入"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-show="ruleForm.terminalProperty == '连锁总部'">
          <el-form-item label="加盟门店数量" >
            <el-input-number v-model="ruleForm.affiliatedShopNum"  :min="0" :max="1000000" label="请输入"></el-input-number>
          </el-form-item>
        </el-col>
       
        <el-col :span="12" v-show="getFieldConfig('chainHeadquartersType', 'formVisible') == 'Y' && ruleForm.terminalProperty == '连锁总部'" :required="getFieldConfig('chainHeadquartersType', 'isRequired') == 'Y'?true:false">
          <!-- 连锁总部类型 -->
          <el-form-item :label="getFieldConfig('chainHeadquartersType', 'fieldAlias')"   >
            <el-select v-model="ruleForm.chainHeadquartersType" :placeholder="getFieldConfig('chainHeadquartersType', 'tipText')" class="w300" filterable>
              <el-option v-for="item in transform(getFieldConfig('chainHeadquartersType', 'selectItemList'))" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属区域" prop="addressList">
            <el-cascader
              ref="cascaderFirst"
              v-model="ruleForm.addressList"
              :options="options"
              class="w300"
              @change="incres"
            ></el-cascader>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <!-- 新增字段-备案名称 -->
          <el-form-item label="备案名称"  >
            <el-input v-model="ruleForm.recordName" class="w300" placeholder="请输入" :maxlength="50" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
        <el-form-item label="药店联系人" prop="contacts">
          <el-input ref="contactsRef"  @input="ruleForm.contacts=ruleForm.contacts.replace(/[^\a-\z\A-\Z\u4E00-\u9FA5]/g,'')" @blur="nameBlur(ruleForm.contacts,ruleForm,'contacts')" v-model="ruleForm.contacts" class="w300" placeholder="请输入"  clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号码">
            <el-input v-model="ruleForm.contactTel"   @input="ruleForm.contactTel=ruleForm.contactTel.replace(/[^\d\-\d]/g,'')"  class="w300" maxlength="13" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="业务指派人员" prop="createUserId">
            <el-select v-model="ruleForm.createUserId" placeholder="请选择" class="w300" filterable>
              <el-option v-for="item in staffList" :key="item.guid" :label="item.staffName" :value="item.guid">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-show="ruleForm.terminalProperty !== '连锁总部'">
          <el-form-item label="经营时长(年)" prop="manageDuration" >
            <el-input-number v-model="ruleForm.manageDuration"  :min="0" :max="1000000" label="请输入"></el-input-number>
            <!-- <el-input v-model="ruleForm.manageDuration" type="number" class="w300" placeholder="请输入" :maxlength="5" clearable></el-input> -->
          </el-form-item>
        </el-col>
        <el-col :span="12" v-show="ruleForm.terminalProperty !== '连锁总部'">
          <el-form-item label="面积(m²)" prop="areaMeasure" >
            <el-input-number v-model="ruleForm.areaMeasure"  :min="0" :max="1000000" label="请输入"></el-input-number>
            <!-- <el-input v-model="ruleForm.areaMeasure" type="number" class="w300" placeholder="请输入" :maxlength="10" clearable></el-input> -->
          </el-form-item>
        </el-col>
        <el-col :span="12" v-show="getFieldConfig('establishDate', 'formVisible') == 'Y' && ruleForm.terminalProperty == '连锁总部'" :required="getFieldConfig('establishDate', 'isRequired') == 'Y'?true:false">
          <!-- 成立时间 -->
          <el-form-item :label="getFieldConfig('establishDate', 'fieldAlias')" >
            <el-col :span="11">
              <el-form-item prop="establishDate">
                <el-date-picker
                  type="date"
                  :placeholder="getFieldConfig('establishDate', 'tipText')"
                  v-model="ruleForm.establishDate"
                  class="w300"
                  :picker-options="expireTimeOption" 
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-show="getFieldConfig('enterpriseNature', 'formVisible') == 'Y' && ruleForm.terminalProperty == '连锁总部'" :required="getFieldConfig('enterpriseNature', 'isRequired') == 'Y'?true:false" >
          <!-- 企业性质 -->
          <el-form-item :label="getFieldConfig('enterpriseNature', 'fieldAlias')"  >
            <el-select v-model="ruleForm.enterpriseNature" :placeholder="getFieldConfig('enterpriseNature', 'tipText')" class="w300" filterable>
              <el-option v-for="item in transform(getFieldConfig('enterpriseNature', 'selectItemList'))" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-show="getFieldConfig('industryStatus', 'formVisible') == 'Y' && ruleForm.terminalProperty == '连锁总部'" :required="getFieldConfig('industryStatus', 'isRequired') == 'Y'?true:false" >
          <!-- 行业地位 -->
          <el-form-item :label="getFieldConfig('industryStatus', 'fieldAlias')"  >
            <el-select v-model="ruleForm.industryStatus" :placeholder="getFieldConfig('industryStatus', 'tipText')" class="w300" filterable>
              <el-option v-for="item in transform(getFieldConfig('industryStatus', 'selectItemList'))" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-show="getFieldConfig('lawsuit', 'formVisible') == 'Y' && ruleForm.terminalProperty == '连锁总部'" :required="getFieldConfig('lawsuit', 'isRequired') == 'Y'?true:false" >
          <!-- 司法官司 -->
          <el-form-item :label="getFieldConfig('lawsuit', 'fieldAlias')"  >
            <el-select v-model="ruleForm.lawsuit" :placeholder="getFieldConfig('lawsuit', 'tipText')" class="w300" filterable>
              <el-option v-for="item in transform(getFieldConfig('lawsuit', 'selectItemList'))" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="建档时间" required>
            <el-col :span="11">
              <el-form-item prop="inputDate">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="ruleForm.inputDate"
                  class="w300"
                  :picker-options="expireTimeOption" 
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-col>
        </el-row>
      </div>
      <!-- 按钮区域 -->
      <div class="operte-btns back-color-fff">
        <el-button size="small" class="" type="info" v-if="txt == '添加资料'" @click="submitForm('ruleForm', 1)"
          >添加下一个</el-button
        >
        <el-button size="small" class="" type="info" v-if="txt != '添加资料'" @click="upDateForm('ruleForm', 1)"
          >添加下一个</el-button
        >
        <el-button size="small" class="" type="info" v-if="txt == '添加资料'" @click="submitForm('ruleForm', 2)"
          >提交</el-button
        >
        <el-button size="small" class="" type="info" v-if="txt != '添加资料'" @click="upDateForm('ruleForm', 2)"
          >提交</el-button
        >
        <el-button plain size="small" @click="back()">取消</el-button>
      </div>
    </el-form>
    
    
      
   
    <!-- <el-dialog title="选择地图" :visible.sync="dialogVisible" width="80%">
      <dialogMap ref="refMap" @getMarkers="getMarkers" @close="close"></dialogMap>
    </el-dialog> -->

    <el-dialog title="地图选点" :visible.sync="dialogVisible"  width="980px">
        <dialogMap v-if="dialogVisible" ref="refMap" :markers="ruleForm.markers" @getMarkers="getMarkers" @close="close"></dialogMap>
    </el-dialog>
    <!-- 重复客户 -->
    <el-dialog title="相似客户" :visible.sync="customerSameDialog" width="1200px">
      <img width="168" src="../../assets/images/repeat_customer.png" alt="" />
      <div class="same-tip">该客户已存在，无法建档，请联系管理员处理</div>
      <el-table :data="commonCustomerList" style="width: 100%" row-key="guid" border class="mt15">
        <el-table-column prop="customerName" label="客户名称" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="terminalProperty"
          label="客户属性"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="venue" label="所在区域" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="address" label="详细地址" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="createUserName"
          label="业务代表"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="mobileNo" label="业务代表电话" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="$router.go(-1)">退出建档</el-button>
        <el-button size="medium" type="info" @click="customerSameDialog = false">返回修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import areaJson from '../../assets/js/china_address_v4.js';
import dialogMap from '../../components/dialogMap';
import recentDate from "@/uilt/recentDate";
export default {
  components: {
    dialogMap,
  },
  data() {
    return {
      tenantList: [],
      txt: '',
      dialogVisible: false,
      options: areaJson,
      fullscreenLoading: false,
      personList: [],
      ruleForm: {
        tenantGuid: '',
        customerName: '',
        createUserId: '',
        terminalProperty: '',
        region: '',
        province: '',
        city: '',
        district: '',
        address: '',
        contacts: '',
        contactTel: '',
        lng: '',
        lat: '',
        inputDate: recentDate.getNowDay(),
        addressList: [],
        markers: '',
        manageDuration: '',
        areaMeasure: '',
        // level: '', //客户等级
        chainHeadquartesGuid: '', //连锁总部Guid
        chainHeadquartesName: '', //连锁总部名称
        recordName: '', //备案名称
        markingPosition:null,//标注位置
        chainHeadquartersType:null,//连锁总部类型
        establishDate:null,//成立时间
        enterpriseNature:null,//企业性质
        industryStatus:null,//行业地位
        lawsuit:null,//司法官司
      },
      addressList: [],
      rules: {
        tenantGuid: [{ required: true, message: '请选择公司', trigger: 'blur' }],
        createUserId: [{ required: true, message: '请选择所属人员姓名', trigger: 'change' }],
        customerName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        contacts: [{ required: true, message: '请输入药店联系人', trigger: 'blur' }],
        // contactTel: [
        //   { required: true, message: '请输入手机号', trigger: 'blur' },
        // ],
        // medName: [
        //   { required: true, message: '请选择医院', trigger: 'blur' },
        // ],
        addressList: [{ type: 'array', required: true, message: '请选择所属区域', trigger: 'change' }],
        address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        markers: [{ required: true, message: '请选择经纬度', trigger: 'blur' }],
        terminalProperty: [{ required: true, message: '请选择药店类型', trigger: 'change' }],
        inputDate: [{ required: true, message: '请选择时间', trigger: 'change' }],
      },
      regionList: [
        {
          value: 'NE',
          name: '东北区',
        },
        {
          value: 'NC',
          name: '华北区',
        },
        {
          value: 'SC',
          name: '华南区',
        },
        {
          value: 'NW',
          name: '西北区',
        },
        {
          value: 'SW',
          name: '西南区',
        },
        {
          value: 'CC',
          name: '华中区',
        },
        {
          value: 'EC',
          name: '华东区',
        },
      ],
      customerTypeList: [
        {
          value: '单体药店',
          label: '单体药店',
        },
        {
          value: '连锁总部',
          label: '连锁总部',
        },
        {
          value: '连锁门店',
          label: '连锁门店',
        },
        {
          value: '诊所',
          label: '诊所',
        },
        {
          value: '乡镇卫生院（含村卫生室）',
          label: '乡镇卫生院（含村卫生室）',
        },
      ],
      joinKeyWords: '',
      staffList: [],
      customerLevelOption: [],
      chainHeadquartesOption: [], //连锁总部下拉
      customerSameDialog: false,
      commonCustomerList: [], //重复客户
      expireTimeOption:{
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      }//时间限制当天以前可选
    };
  },
  watch: {},
  created() {
    if (this.$route.query.guid) {
      this.txt = '编辑资料';
      this.getCustomerDetail();
    } else {
      this.reset();
      this.getChainHeadquartes('');
      if (this.$route.query.tenantGuid) {
        // this.ruleForm.tenantGuid = this.$route.query.tenantGuid;
        // this.medPage.tenantGuid = this.$route.query.tenantGuid;
        this.getStaffList(this.$route.query.tenantGuid);
      }
    }
    this.getTenantOperationRelList(false);
  },
  methods: {
    //获取配置下拉选项
    transform(list, type) {
      var newList = [];
      if (list && list.length > 0) {
        list.forEach((item) => {
          newList.push({
            label: item.text,
            value: item.value,
          });
        });
      }
      return newList;
    },
    //获取配置对应字段
    getFieldConfig(params, key) {
      var fieldList = JSON.parse(localStorage.getItem('KAYDJD_CONFIG')).fieldList;
      var newConfig = {};
      fieldList.forEach((item) => {
        if (item.fieldName == params) {
          newConfig = item;
        }
      });
      return newConfig && newConfig[key];
    },
    //获取连锁总部
    getChainHeadquartes(val) {
      let self = this;
      if(!self.ruleForm.tenantGuid){
        return
      }
      let query = {
        pageIndex: 1,
        tenantGuid: self.ruleForm.tenantGuid,
        pageSize: 30,
        keyword: val, 
        customerType: '5'
      };
      this.api.postJson(`/${serverConfig.msCustomerService}/customer/get-customer-es`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.chainHeadquartesOption = res.data.data.records || [];
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    getTenantOperationRelList() {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true` +
            '&tenantGuid=' +
            localStorage.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.tagsLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.tenantList = res.data.data;
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    tenantChange() {
      let self = this;
      self.ruleForm.chainHeadquartesGuid = null;
      self.ruleForm.chainHeadquartesName = null;
      self.ruleForm.createUserId = null;
      self.getStaffList(self.ruleForm.tenantGuid);
      self.checkCommonCustomer(self.ruleForm.tenantGuid);
      self.getChainHeadquartes('');

    },
    getStaffList(tenantGuid) {
      if (!tenantGuid) {
        this.$message.error('请选择公司名称！');
        return;
      }
      this.api
        .get(`/${serverConfig.msPersonnelService}/staff/get-staff-by-tenantGuid?tenantGuid=` + tenantGuid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.staffList = res.data.data;
          } else {
            this.$message.error(res.data.data.msg);
          }
        });
    },
    handleChange(value) {
      console.log(value);
    },
    showMap() {
      this.dialogVisible = true;
    },
    getMarkers(marker) {
      this.dialogVisible = false;
      this.ruleForm.markers = marker;
      this.ruleForm.addressList = [marker.province,marker.city,marker.district];
      this.ruleForm.address = marker.address;
      this.ruleForm.markingPosition = marker.address;
      console.log('markermarker', marker);
    },
    close() {
      this.dialogVisible = false;
    },
    //检测客户名称是否重复
    checkCommonCustomer(val) {
      let self = this;
      if (val) {
        let patrn = /[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g;
        if (patrn.test(val)) {
          // 如果包含特殊字符返回false
          self.$message.error(`${self.ruleForm.terminalProperty == '连锁门店'?'分店':'药店'}名称只能输入汉字、英文、数字!`);
          self.ruleForm.customerName = null;
          return;
        }
      }else{
        return;
      }
      if(val && self.ruleForm.terminalProperty == '连锁门店' && (val.includes('连锁') || val.includes('药店'))){
        self.$message.error(`分店名称不规范，不可包含“连锁、药店”等字`);
        self.ruleForm.customerName = null;
        return
      }
      // if(val && self.ruleForm.terminalProperty == '连锁总部' && !val.includes('连锁')){
      //   self.$message.error(`连锁总部名称不规范，需包含“连锁”二字`);
      //   self.ruleForm.customerName = null;
      //   return
      // }
      if(!self.ruleForm.tenantGuid){
        self.$message.error(`请先选择公司名称`);
        return
      }
      self.api
        .get(
          `/${serverConfig.msCustomerService}/common/data/check-exists?customerName=${val}&customerType=6&tenantGuid=${self.ruleForm.tenantGuid}`,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.commonCustomerList = res.data.data ? [res.data.data] : [];
            this.customerSameDialog = res.data.data ? true : false;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getCustomerDetail(guid) {
      let self = this;
      self.staffDetail = '';
      self.defaultCheckedKeys = [];
      self.api
        .get(`/${serverConfig.msCustomerService}/potential/customer/get-detail?guid=${this.$route.query.guid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.staffDetail = res.data.data;
            let marker = {
              lat: self.staffDetail.lat,
              lng: self.staffDetail.lng,
            };
            console.log(self.ruleForm.markers);
            let date = self.staffDetail.inputDate?self.$moment(self.staffDetail.inputDate).format('YYYY-MM-DD'):null; 
            this.ruleForm = {
              tenantGuid: self.staffDetail.tenantGuid,
              customerName: self.staffDetail.customerName,
              terminalProperty: self.staffDetail.terminalProperty,
              createUserId: self.staffDetail.staffGuid,
              region: self.staffDetail.region,
              province: self.staffDetail.province,
              city: self.staffDetail.city,
              district: self.staffDetail.district,
              venue: self.staffDetail.venue,
              address: self.staffDetail.address,
              contacts: self.staffDetail.contacts,
              contactTel: self.staffDetail.contactTel,
              lng: self.staffDetail.lng,
              lat: self.staffDetail.lat,
              inputDate: date,
              addressList: [self.staffDetail.province, self.staffDetail.city, self.staffDetail.district],
              markers: marker,
              manageDuration: self.staffDetail.manageDuration,
              areaMeasure: self.staffDetail.areaMeasure,
              directStoresNum:self.staffDetail.directStoresNum,//直营门店数量
              affiliatedShopNum:self.staffDetail.affiliatedShopNum,//加盟门店数量
              // level: self.staffDetail.level, //客户等级
              chainHeadquartesGuid: self.staffDetail.chainHeadquartesGuid, //连锁总部
              chainHeadquartesName: self.staffDetail.chainHeadquartersName, //连锁总部名称
              recordName: self.staffDetail.recordName, //备案名称
              markingPosition:self.staffDetail.markingPosition,//标注位置
              chainHeadquartersType:self.staffDetail.chainHeadquartersType,//连锁总部类型
              establishDate:self.staffDetail.establishDate?self.$moment(self.staffDetail.establishDate).format('YYYY-MM-DD'):null,//成立时间
              enterpriseNature:self.staffDetail.enterpriseNature,//企业性质
              industryStatus:self.staffDetail.industryStatus,//行业地位
              lawsuit:self.staffDetail.lawsuit//司法官司
            };
            self.getChainHeadquartes(self.ruleForm.chainHeadquartesName);
            self.getStaffList(self.ruleForm.tenantGuid);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    reset() {
      this.txt = '添加资料';
      this.ruleForm = {
        tenantGuid: '',
        customerName: '',
        createUserId: '',
        terminalProperty: '',
        region: '',
        province: '',
        city: '',
        district: '',
        address: '',
        contacts: '',
        contactTel: '',
        lng: '',
        lat: '',
        inputDate: recentDate.getNowDay(),
        addressList: [],
        markers: '',
        manageDuration: '',
        areaMeasure: '',
        // level: '', //客户等级
        chainHeadquartesGuid: '', //连锁总部Guid
        chainHeadquartesName: '', //连锁总部名称
        recordName: '', //备案名称
        markingPosition:'',//标注位置
        chainHeadquartersType:null,//连锁总部类型
        establishDate:null,//成立时间
        enterpriseNature:null,//企业性质
        industryStatus:null,//行业地位
        lawsuit:null//司法官司
      };
    },
    incres(area) {
      const checkedNodes = this.$refs['cascaderFirst'].getCheckedNodes();
      let arr = checkedNodes[0].pathNodes;
      let codeArr = [];
      arr.forEach((item) => {
        codeArr.push(item.data.value);
      });
      this.ruleForm.province = codeArr[0];
      this.ruleForm.city = codeArr[1];
      this.ruleForm.district = codeArr[2];
      let venue = '';
      if (codeArr) {
        if (codeArr[0]) {
          venue = this.province(codeArr[0]);
        }
        if (codeArr[1]) {
          venue = this.province(codeArr[0]) + '/' + this.city(codeArr[1]);
        }
        if (codeArr[2]) {
          venue = this.province(codeArr[0]) + '/' + this.city(codeArr[1]) + '/' + this.district(codeArr[2]);
        }
      }
      this.ruleForm.venue = venue;
    },
    province(val) {
      let pr = '';
      this.options.forEach(function (j) {
        if (j.value == val) {
          pr = j.label;
        }
      });
      return pr;
    },
    city(val) {
      let ci = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.value == val) {
              ci = j.label;
            }
          });
        }
      });
      return ci;
    },
    district(val) {
      let di = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.children != null && j.children != '') {
              j.children.forEach(function (n) {
                if (n.value == val) {
                  di = n.label;
                }
              });
            }
          });
        }
      });
      return di;
    },
    changeChainHeadquartesName(val){
      let self = this;
      if(val){
        if (self.chainHeadquartesOption.length > 0) {
          self.chainHeadquartesOption.forEach((i) => {
            if (i.commonGuid == self.ruleForm.chainHeadquartesGuid) {
              self.ruleForm.chainHeadquartesName = i.customerName;
            }
          });
        }
      }
    },
    submitForm(formName, flg) {
      let self = this;
      if (self.ruleForm.customerName) {
        let patrn = /[^\u4E00-\u9FA5]/g;
        // if (patrn.test(self.ruleForm.customerName)) {
        //   // 如果包含特殊字符返回false
        //   self.$message.error('药店名称只能输入汉字，不可输入数字、字母和特殊字符!');
        //   return;
        // }
      }
      // if (this.ruleForm.contactTel) {
      //   let regs = /^((13[0-9])|(17[0-1,6-8])|(15[^4,\\D])|(18[0-9]))\d{8}$/;
      //   if (!regs.test(this.ruleForm.contactTel)) {
      //     this.$message.error('手机号格式不正确！');
      //     return;
      //   }
      // }
      // 连锁总部类型
      if (!this.ruleForm.chainHeadquartersType&&this.getFieldConfig("chainHeadquartersType", "formVisible") == "Y" &&this.getFieldConfig("chainHeadquartersType", "isRequired") == "Y" && this.ruleForm.terminalProperty == '连锁总部') {
        this.$message.error(`${this.getFieldConfig("chainHeadquartersType", "fieldAlias")}不能为空`);
        return;
      }
      // 成立时间
      if (!this.ruleForm.establishDate&&this.getFieldConfig("establishDate", "formVisible") == "Y" &&this.getFieldConfig("establishDate", "isRequired") == "Y" && this.ruleForm.terminalProperty == '连锁总部') {
        this.$message.error(`${this.getFieldConfig("establishDate", "fieldAlias")}不能为空`);
        return;
      }
      // 企业性质
      if (!this.ruleForm.enterpriseNature&&this.getFieldConfig("enterpriseNature", "formVisible") == "Y" &&this.getFieldConfig("enterpriseNature", "isRequired") == "Y" && this.ruleForm.terminalProperty == '连锁总部') {
        this.$message.error(`${this.getFieldConfig("enterpriseNature", "fieldAlias")}不能为空`);
        return;
      }
      // 行业地位
      if (!this.ruleForm.industryStatus&&this.getFieldConfig("industryStatus", "formVisible") == "Y" &&this.getFieldConfig("industryStatus", "isRequired") == "Y" && this.ruleForm.terminalProperty == '连锁总部') {
        this.$message.error(`${this.getFieldConfig("industryStatus", "fieldAlias")}不能为空`);
        return;
      }
      // 司法官司
      if (!this.ruleForm.lawsuit&&this.getFieldConfig("lawsuit", "formVisible") == "Y" &&this.getFieldConfig("lawsuit", "isRequired") == "Y" && this.ruleForm.terminalProperty == '连锁总部') {
        this.$message.error(`${this.getFieldConfig("lawsuit", "fieldAlias")}不能为空`);
        return;
      }
      if (this.$NameCheck(this,this.ruleForm.contacts,'contacts')) { // todo 姓名长度校验
          return
      }
      self.$refs[formName].validate((valid) => {
        if (valid) {
          let promise = {
            tenantGuid: self.ruleForm.tenantGuid,
            customerName: self.ruleForm.customerName,
            staffGuid: self.ruleForm.createUserId,
            terminalProperty: self.ruleForm.terminalProperty,
            province: self.ruleForm.addressList[0],
            city: self.ruleForm.addressList[1],
            district: self.ruleForm.addressList[2],
            address: self.ruleForm.address,
            venue: self.ruleForm.venue,
            contacts: self.ruleForm.contacts,
            contactTel: self.ruleForm.contactTel,
            lng: self.ruleForm.markers.lng,
            lat: self.ruleForm.markers.lat,
            inputDate: self.ruleForm.inputDate,
            areaMeasure: self.ruleForm.areaMeasure,
            manageDuration: self.ruleForm.manageDuration,
            // level: self.ruleForm.level,
            chainHeadquartesGuid: self.ruleForm.chainHeadquartesGuid, //连锁总部Guid
            chainHeadquartesName: self.ruleForm.chainHeadquartesName, //连锁总部名称
            recordName: self.ruleForm.recordName, //备案名称
            directStoresNum:self.ruleForm.directStoresNum,//直营门店数量
            affiliatedShopNum:self.ruleForm.affiliatedShopNum,//加盟门店数量
            markingPosition:self.ruleForm.markingPosition,//标注位置
            chainHeadquartersType:self.ruleForm.chainHeadquartersType,//连锁总部类型
            establishDate:self.ruleForm.establishDate?self.$moment(self.ruleForm.establishDate).format('YYYY-MM-DD'):null,//成立时间
            enterpriseNature:self.ruleForm.enterpriseNature,//企业性质
            industryStatus:self.ruleForm.industryStatus,//行业地位
            lawsuit:self.ruleForm.lawsuit,//司法官司
            serviceTenantGuid:localStorage.guid
          };
          if(promise.terminalProperty == '连锁总部'){
            promise.areaMeasure = null;
            promise.manageDuration = null;
          }else{
            promise.directStoresNum = 0;
            promise.affiliatedShopNum = 0;
          }
          if(promise.terminalProperty !== '连锁门店'){
            promise.chainHeadquartesGuid = null;
            promise.chainHeadquartesName = null;
          }
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msCustomerService}/potential/customer/add`, promise).then((res) => {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('提交成功');
              self.$refs[formName].resetFields();
              if (flg == 1) {
                self.reset();
              } else {
                self.$router.push({ path: '/pharmacyPotentialList', query: { tenantGuid: self.$route.query.tenantGuid } });
              }
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    upDateForm(formName, flg) {
      let self = this;
      if (self.ruleForm.customerName) {
        let patrn = /[^\u4E00-\u9FA5]/g;
        // if (patrn.test(self.ruleForm.customerName)) {
        //   // 如果包含特殊字符返回false
        //   self.$message.error('药店名称只能输入汉字，不可输入数字、字母和特殊字符!');
        //   return;
        // }
      }
      // if (self.ruleForm.contactTel) {
      //   let regs = /^((13[0-9])|(17[0-1,6-8])|(15[^4,\\D])|(18[0-9]))\d{8}$/;
      //   if (!regs.test(self.ruleForm.contactTel)) {
      //     self.$message.error('手机号格式不正确！');
      //     return;
      //   }
      // }
      // 连锁总部类型
      if (!this.ruleForm.chainHeadquartersType&&this.getFieldConfig("chainHeadquartersType", "formVisible") == "Y" &&this.getFieldConfig("chainHeadquartersType", "isRequired") == "Y" && this.ruleForm.terminalProperty == '连锁总部') {
        this.$message.error(`${this.getFieldConfig("chainHeadquartersType", "fieldAlias")}不能为空`);
        return;
      }
      // 成立时间
      if (!this.ruleForm.establishDate&&this.getFieldConfig("establishDate", "formVisible") == "Y" &&this.getFieldConfig("establishDate", "isRequired") == "Y" && this.ruleForm.terminalProperty == '连锁总部') {
        this.$message.error(`${this.getFieldConfig("establishDate", "fieldAlias")}不能为空`);
        return;
      }
      // 企业性质
      if (!this.ruleForm.enterpriseNature&&this.getFieldConfig("enterpriseNature", "formVisible") == "Y" &&this.getFieldConfig("enterpriseNature", "isRequired") == "Y" && this.ruleForm.terminalProperty == '连锁总部') {
        this.$message.error(`${this.getFieldConfig("enterpriseNature", "fieldAlias")}不能为空`);
        return;
      }
      // 行业地位
      if (!this.ruleForm.industryStatus&&this.getFieldConfig("industryStatus", "formVisible") == "Y" &&this.getFieldConfig("industryStatus", "isRequired") == "Y" && this.ruleForm.terminalProperty == '连锁总部') {
        this.$message.error(`${this.getFieldConfig("industryStatus", "fieldAlias")}不能为空`);
        return;
      }
      // 司法官司
      if (!this.ruleForm.lawsuit&&this.getFieldConfig("lawsuit", "formVisible") == "Y" &&this.getFieldConfig("lawsuit", "isRequired") == "Y" && this.ruleForm.terminalProperty == '连锁总部') {
        this.$message.error(`${this.getFieldConfig("lawsuit", "fieldAlias")}不能为空`);
        return;
      }
      if (this.$NameCheck(this,this.ruleForm.contacts,'contacts')) { // todo 姓名长度校验
          return
      }
      self.$refs[formName].validate((valid) => {
        if (valid) {
          let promise = {
            guid: self.$route.query.guid,
            tenantGuid: self.ruleForm.tenantGuid,
            customerName: self.ruleForm.customerName,
            staffGuid: self.ruleForm.createUserId,
            terminalProperty: self.ruleForm.terminalProperty,
            province: self.ruleForm.addressList[0],
            city: self.ruleForm.addressList[1],
            district: self.ruleForm.addressList[2],
            address: self.ruleForm.address,
            venue: self.ruleForm.venue,
            contacts: self.ruleForm.contacts,
            contactTel: self.ruleForm.contactTel,
            lng: self.ruleForm.markers.lng,
            lat: self.ruleForm.markers.lat,
            inputDate: self.ruleForm.inputDate,
            areaMeasure: self.ruleForm.areaMeasure,
            manageDuration: self.ruleForm.manageDuration,
            // level: self.ruleForm.level,
            chainHeadquartesGuid: self.ruleForm.chainHeadquartesGuid, //连锁总部Guid
            chainHeadquartesName: self.ruleForm.chainHeadquartesName, //连锁总部名称
            recordName: self.ruleForm.recordName, //备案名称
            directStoresNum:self.ruleForm.directStoresNum,//直营门店数量
            affiliatedShopNum:self.ruleForm.affiliatedShopNum,//加盟门店数量
            markingPosition:self.ruleForm.markingPosition,//标注位置
            chainHeadquartersType:self.ruleForm.chainHeadquartersType,//连锁总部类型
            establishDate:self.ruleForm.establishDate?self.$moment(self.ruleForm.establishDate).format('YYYY-MM-DD'):null,//成立时间
            enterpriseNature:self.ruleForm.enterpriseNature,//企业性质
            industryStatus:self.ruleForm.industryStatus,//行业地位
            lawsuit:self.ruleForm.lawsuit,//司法官司
            serviceTenantGuid:localStorage.guid
          };
          if(promise.terminalProperty == '连锁总部'){
            promise.areaMeasure = null;
            promise.manageDuration = null;
          }else{
            promise.directStoresNum = 0;
            promise.affiliatedShopNum = 0;
          }
          if(promise.terminalProperty !== '连锁门店'){
            promise.chainHeadquartesGuid = null;
            promise.chainHeadquartesName = null;
          }
          self.fullscreenLoading = true;
          self.api.put(`/${serverConfig.msCustomerService}/potential/customer/update`, promise).then((res) => {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('提交成功');
              self.$refs[formName].resetFields();
              if (flg == 1) {
                self.reset();
              } else {
                self.$router.push({ path: '/pharmacyPotentialList', query: { tenantGuid: self.$route.query.tenantGuid } });
              }
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    back() {
      let self = this;
      self.$router.push({ path: '/pharmacyPotentialList', query: { tenantGuid: self.$route.query.tenantGuid } });
    },
    /**
     * @param val 对应值
     * @param formObj 表单对象
     * @param fildeName 字段key
    */
    nameBlur(val,formObj,fildeName) {
      formObj[fildeName] = this.$NameCheckBlur(this,val,fildeName)
      
    }
  },
};
</script> 
<style scoped>
/deep/ .el-input__inner{
  height:40px;
  line-height:36px
}
.button-groups {
  display: flex;
  justify-content: center;
  margin-bottom: 50px;
  margin-top: 50px;
}
.map-a-sty {
  width: 90px;
  height: 28px;
  line-height: 28px;
  color: #4fa1a4;
  margin-top: 5px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #4fa1a4;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
}
.content {
  margin: 0px;
}
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.costApprove {
  text-align: left;
  background: #fff;
  margin: 16px;
  padding: 20px 30px;
  display: flow-root;
}

.cost-title {
  height: 72px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.cost-title .flow-name {
  color: #323233;
  font-size: 20px;
}
.cost-title .task-tips {
  margin-left: 20px;
}
.cost-title .flow-back {
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  color: #323233;
  padding: 0 26px;
  border: 1px solid #c8c9cd;
  cursor: pointer;
}
.cost-title-list {
  display: flex;
  align-items: center;
  height: 32px;
  line-height: 32px;
  padding-left: 20px;
  background: #f6f7fa;
}
.cost-title-list-line {
  display: inline-block;
  width: 6px;
  height: 14px;
  background: #4fa1a4;
}
.cost-title-list-txt {
  font-size: 18px;
  color: #323233;
  padding-left: 6px;
}
.cost-approve-list {
  display: flex;
  margin: 18px 0;
  position: relative;
  margin-bottom: 10px;
  width: 860px;
}
.cost-approve-list .tips {
  position: absolute;
  color: red;
  font-size: 12px;
  bottom: -6px;
  left: 145px;
}

.cost-approve-list-title {
  width: 145px;
  text-align: right;
  flex-shrink: 0;
  line-height: 40px;
  padding-left: 25px;
  box-sizing: border-box;
}
.cost-approve-list-content {
  flex: 1;
}
.cost-submit-btn {
  display: flex;
  justify-content: center;
  /* padding: 50px 0; */
  padding-bottom: 20px;
}
.cost-submit-btn-sure {
  color: #fff;
  width: 112px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #4fa1a4;
  cursor: pointer;
  margin-left: 20px;
}
.cost-submit-btn-cancel {
  color: #fff;
  width: 112px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #c8c9cc;
  cursor: pointer;
}
.cost-approve-list-content a {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  line-height: 40px;
}
.cost-header {
  display: flex;
  background: #f0f0f0;
  font-size: 12px;
  border-right: 1px solid #dfdfdf;
}
.cost-header .header-child {
  flex: 1;
  padding: 10px;
  border-right: 1px solid #dfdfdf;
}
.cost-header .header-child:last-child {
  border-right: 0 none;
}
.cost-wrap {
  border: 1px solid #dfdfdf;
  border-right: 0 none;
}
.cost-list-content {
  display: flex;
  border-bottom: 1px solid #dfdfdf;
}
.cost-list-content:last-child {
  border-bottom: 0 none;
}
.cost-list-content .header-child {
  flex: 1;
  padding: 10px;
  display: flex;
  align-items: center;
  border-right: 1px solid #dfdfdf;
}
.cost-list-content .add {
  color: #4fa1a4;
  cursor: pointer;
}
.cost-list-content .del {
  color: #d0021b;
  cursor: pointer;
}
.header-select span {
  margin-left: 6px;
}
.cost-row {
  display: flex;
}
.cost-row .cost-approve-list {
  width: 500px;
}
.cost-row-colum {
  width: 860px;
}
.cost-sub-title {
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  padding-left: 60px;
  margin-top: 10px;
}
.cost-sub-title .line {
  width: 860px;
  height: 1px;
  background: #dadada;
  margin-left: 20px;
}
.margin100 {
  margin-left: 60px;
}
/deep/ .el-dialog__body {
  padding: 10px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
/deep/ .el-dialog__footer {
  padding: 0px 20px 20px;
  text-align: right;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.header-sty {
  width: 100%;
  height: 65px;
  line-height: 65px;
}
.txt-sty {
  color: #323233;
  font-size: 20px;
  float: left;
  width: 90%;
  text-align: center;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type='number'] {
  -moz-appearance: textfield;
}
/* .demo-ruleForm {
  display: flex;
  flex-wrap: wrap;
} */
</style>
<style>
.reimbursement-check /deep/.el-checkbox__label {
  display: none !important;
}
.twoAn {
  color: #4fa1a4;
  font-size: 14px;
  margin-right: 10px;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 10px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.select-box {
  display: flex;
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.addPeople {
  width: 84px;
  height: 28px;
  margin-top: 5px;
  border: 1px solid #4fa1a4;
  text-align: center;
  line-height: 28px;
  color: #4fa1a4;
}
/* .mt20 .el-form-item__content {
  width: 830px;
} */
</style>
<style lang="less" scoped>
.content {
  padding: 0px;
  margin: 0px;
  // padding-bottom: 60px;
  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;
    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }
    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }
  .form-box {
    margin-top: 4px;
    text-align: left;
    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
    }
    .form-item-box {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 15px;
    }
    .el-col-12 {
      margin-bottom: 14px;
    }
    .el-form-item {
      margin-bottom: 0px;
    }
    .el-input,
    .el-select {
      width: 314px;
    }
    .age-are-box {
      display: flex;
      align-items: center;
      .el-input {
        width: 142px;
      }
      span {
        margin: 0px 8px;
      }
    }
    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;
    }
  }

  /deep/ .el-form-item__error {
    padding-top: 0px;
  }
  .el-button--primary {
    color: #ffffff;
  }

  .file-list-box {
    display: flex;
    // justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 32px;
    .upload-file-box {
      max-width: calc(100% - 132px - 16px);
    }
    .btn-box {
      position: absolute;
      width: 180px;
      margin-left: 16px;
      height: 32px;
      left: 430px;
    }
  }
  .operte-btns {
    background: #fff;
    margin-top: 2px;
    display: flex;
    justify-content: center;
    padding: 25px 0;
  }

  .operte-btns .btn {
    padding: 5px 18px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;
    margin-right: 10px;
  }

  .operte-btns .btn.save {
    border: 1px solid rgba(79, 161, 164, 1);
    color: rgba(79, 161, 164, 1);
    cursor: pointer;
  }

  .operte-btns .btn.submit {
    border: 1px solid rgba(79, 161, 164, 1);
    background: rgba(79, 161, 164, 1);
    color: #fff;
    cursor: pointer;
  }
}
/deep/ .el-upload__tip {
  line-height: 1;
  margin-top: 8px;
}
.sub-title {
  line-height: 28px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.sub-operate-add {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
}
.sub-operate-add2 {
  position: absolute;
  right: 0px;
  top: -35px;
}
.sub-operate-add3 {
  position: absolute;
  right: 30px;
  top: 5px;
}
/deep/.el-select-dropdown .el-select-dropdown__item {
  color: #212121;
}
/deep/ .el-upload-list__item {
  // width
  max-width: 430px;
}
</style>